import { apiService } from "../../../utils/api/api.service";
import { requestWithErrorHandling } from "../../../utils/error/handle.error";

class SocialService {
  private static instance: SocialService;

  static getInstance(): SocialService {
    if (!SocialService.instance) {
      SocialService.instance = new SocialService();
    }
    return SocialService.instance;
  }

  getAccounts = () => {
    return requestWithErrorHandling(async () => {
      return await apiService.get("/social-accounts");
    });
  };

  getStatus = () => {
    return requestWithErrorHandling(async () => {
      return await apiService.get("/social-accounts/status");
    });
  };

  connect = (
    provider: string,
    providerId: string,
    providerEmail?: string,
    providerName?: string,
    accessToken?: string,
    refreshToken?: string
  ) => {
    return requestWithErrorHandling(async () => {
      return await apiService.post("/social-accounts/connect", {
        provider,
        providerId,
        providerEmail,
        providerName,
        accessToken,
        refreshToken,
      });
    });
  };

  disconnect = (provider: string) => {
    return requestWithErrorHandling(async () => {
      return await apiService.delete(`/social-accounts/${provider}`);
    });
  };
}

export const socialService = SocialService.getInstance();
